import React from 'react'
import {BadgeList} from '../../../game/stats/components/BadgeListComponent'

import moment from 'moment'
moment.locale('fr')

class Player extends React.Component {
    render() {
        const {date, player} = this.props
        return (
            <div className="player">
                <div className="wrapper">
                    <div className="avatar" style={{backgroundImage: 'url(' + player.image + ')'}}/>
                </div>
                <span className="name">{player.name}</span>
                <span className="score">{player.total}</span>
                <div>
                    {BadgeList(player)}
                </div>

                {date ? <div style={{marginTop:'5px'}}><span className=""> {moment(date).format('LL')}</span></div> : null}

            </div>
        )
    }
}

class PlayerListItem extends React.Component {
    render() {
        const {date, player} = this.props
        return (
            <div className="player">
                <div className="wrapper">
                    <div className="avatar" style={{backgroundImage: 'url(' + player.image + ')'}}/>
                </div>
                <span className="name">{player.name}</span>
                <span className="score">{player.total}</span>
                {date ? <span className="score pull-right"> {moment(date).format('LL')}</span> : null}
            </div>
        )
    }
}

export default class PodiumComponent extends React.Component {
    constructor() {
        super()
        this.PlayerConstructor = Player
        this.PlayerListItemConstructor = PlayerListItem
    }

    render() {
        const {date, players} = this.props
        const PlayerConstructor = this.PlayerConstructor
        const PlayerListItemConstructor = this.PlayerListItemConstructor
        const leaders = players.slice(0, 3).map(player => <PlayerConstructor date={date} key={player.id}
                                                                             player={player}/>)
        const others = players.slice(3, players.length)
            .map(player => <PlayerListItemConstructor date={date} key={player.id} player={player}/>)
        return (
            <div className="podium">
                <div className="leaders">
                    {leaders}
                </div>
                <div className="others">
                    {others}
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/game/leaderboards/components/PodiumComponent.jsx